import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import * as i2 from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { __awaiter } from 'tslib';

/**
 *
 * Analytics Lib (GA) for Angular CLI v13
 * @version 1.0.0 (2022-01-20)
 *
 * @author Diego Riccio (Accenture Interactive)
 * @author Lucas Domingues (Accenture Interactive)
 *
 */
/**
 * Esta libreria contiene los metodos que realizan la conexion entre la aplicacion y Google Tag Manager
 */
class Analytics {
    /**
     * @ignore
     */
    constructor() {
        /**
         * @ignore
         */
        this.enabled = true;
        /**
         * @ignore
         */
        this.expose = false;
        /**
         * @ignore
         */
        this.adobeDataLayerName = 'analyticsData';
        /**
         * @ignore
         */
        this.debug = false;
        /**
         * @ignore
         */
        this.debugColor = 'font-weight: bold; color: red';
        /**
         * @ignore
         */
        this.autoTrackState = false;
        /**
         * @ignore
         */
        this.listClassification = [
            'site.platformdetails',
            'site.applicationdetails',
            'visitor.customerdetails',
            'visitor.elegibility',
            'transaction.details',
            'custom.logintype',
            'custom.surveyscore',
            'custom.whatevervariable'
        ];
        /**
         * @ignore
         */
        this.adobeToGoole = {
            'site.vrsid': 'site.channel',
            'site.assessibility': 'site.accessibility',
            'site.assessibilitystatus': 'site.accessibility',
            'site.activatedpermissions': 'site.permissions',
            'site.platform': 'site.developmenttype',
            'site.platformdetails.AM': 'site.environment',
            'site.platformdetails.VA': 'site.environment',
            'site.platformdetails.UA': 'site.useragent',
            'site.applicationdetails.AG': 'visitor.agencystoreid',
            'visitor.customerid': 'visitor.client.idpf',
            'visitor.companyid': 'visitor.client.idpjcompany',
            'visitor.companyoperator': 'visitor.client.idpjoperator',
            'visitor.customerdetails.TP': 'visitor.client.accounttype',
            'visitor.customerdetails.AG': 'visitor.client.agency',
            'visitor.customersegment': 'visitor.client.commercialsegment',
            'visitor.customerdetails.FF': 'visitor.client.declaredincomerange',
            'visitor.customerdetails.LM': 'visitor.client.limitusage',
            'visitor.customerdetails.PPC': 'visitor.client.loannearduedate',
            'visitor.customerdetails.RA': 'visitor.client.occupation',
            'visitor.customerdetails.PERF': 'visitor.client.profile',
            'visitor.customerdetails.PP': 'visitor.client.rewardsprogram',
            'visitor.customerdetails.SCR': 'visitor.client.score',
            'visitor.customerdetails.EST': 'visitor.client.stars',
            'visitor.customerdetails.CTT': 'visitor.client.titularitycode',
            'visitor.customerdetails.SE': 'visitor.client.type',
            'visitor.elegibility.PA': 'visitor.client.elegibility',
            'visitor.storeid': 'visitor.agencystoreid',
            'transaction.details.CTB': 'transaction.details.bonusinstallments',
            'transaction.details.VR': 'transaction.details.cardcategory',
            'transaction.details.LMT': 'transaction.details.cardlimitrange',
            'transaction.details.BD': 'transaction.details.cardnetwork',
            'transaction.details.PT': 'transaction.details.cardpartner',
            'transaction.details.DCP': 'transaction.details.cardpurchaselimitrange',
            'transaction.details.DEF': 'transaction.details.cardwithdrawallimitrange',
            'transaction.details.CAN': 'transaction.details.chosenchannel',
            'transaction.details.PTS': 'transaction.details.clientrewardsvaluerange',
            'transaction.details.CUR': 'transaction.details.currency',
            'transaction.details.ACR': 'transaction.details.daystoinvoiceclosure',
            'transaction.details.TCD': 'transaction.details.destinationaccounttype',
            'transaction.details.BCD': 'transaction.details.destinationbank',
            'transaction.details.PLZ': 'transaction.details.installmentsterm',
            'transaction.details.CT': 'transaction.details.installmentsterm',
            'transaction.details.LMP': 'transaction.details.loanlimitrange',
            'transaction.details.PAO': 'transaction.details.offeredlimitincreaserange',
            'transaction.details.TCO': 'transaction.details.originaccounttype',
            'transaction.details.MDP': 'transaction.details.paymentmethod',
            'transaction.details.CAT': 'transaction.details.productcategory',
            'transaction.details.DP': 'transaction.details.productdetails',
            'transaction.details.PAS': 'transaction.details.requestedlimitincreaserange',
            'transaction.details.TS': 'transaction.details.tax',
            'transaction.details.INST': 'transaction.details.transactioninstitution',
            'transaction.details.STS': 'transaction.details.transactionstatus',
            'transaction.details.PVJ': 'transaction.details.travelnoticedestinationcountry',
            'transaction.details.FVI': 'transaction.details.travelnoticeinbounddate',
            'transaction.details.FVR': 'transaction.details.travelnoticeoutbounddate',
            'custom.partnerid': 'custom.confirmationid',
            'custom.internalid': 'custom.leadid',
            'custom.logintype.TA': 'custom.login.authenticationtype',
            'custom.logintype.TL': 'custom.login.type',
            'custom.surveyscore.RE': 'custom.survey.results',
            'custom.surveyscore.TG': 'custom.survey.tag',
            'custom.surveyscore.TP': 'custom.survey.type',
            'custom.whatevervariable.MSG': 'custom.message'
        };
    }
    /**
     * @ignore
     */
    init(config) {
        const self = this;
        // Valores de configuração definidos no import da Lib
        if ('object' === typeof config) {
            config['enabled'] === undefined || (self.enabled = config['enabled']);
            config['expose'] === undefined || (self.expose = config['expose']);
            config['adobeDataLayerName'] === undefined || (self.adobeDataLayerName = config['adobeDataLayerName']);
            config['debug'] === undefined || (self.debug = config['debug']);
            config['debugColor'] === undefined || (self.debugColor = config['debugColor']);
            config['gtmContainerId'] === undefined || (self.gtmContainerId = config['gtmContainerId']);
            config['autoTrackState'] === undefined || (self.autoTrackState = config['autoTrackState']);
        }
        if (self.enabled) {
            try {
                if (config['gtmContainerId']) {
                    // Google Tag Manager
                    (function (w, d, s, l, i) {
                        w[l] = w[l] || [];
                        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                        var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                        j['async'] = true;
                        j['src'] =
                            'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                        f.parentNode.insertBefore(j, f);
                    })(window, document, 'script', 'dataLayer', self.gtmContainerId);
                }
                else {
                    self.debug && console.log('Container do GTM não informado!');
                }
                // DataLayer padrão Adobe
                window[self.adobeDataLayerName] = window[self.adobeDataLayerName] || {};
                // DataLayer padrão Google
                window['dataLayer'] = window['dataLayer'] || [];
                // Disparo do pageView
                self.autoTrackState && self.trackState();
                self.debug && console.log('%cAnalytics - Constructor: ', self.debugColor, 'DataLayer built!');
                self.expose ? window['analyticsLib'] = self : window['analyticsLib'] = {};
                // Precisa sempre star exposto no Window para funcionamento da variáveis no GTM
                window['analyticsLib'].adobeDataLayerName = self.adobeDataLayerName;
            }
            catch (e) {
                self.debug && console.log('%cAnalytics - init - Error', self.debugColor, e);
            }
        }
    }
    /**
     * @ignore
     */
    pageStart() {
        const self = this;
        try {
            self.setData('page.loadStart', (new Date).getTime());
            self.setData('custom', {});
            self.debug && console.log('%cAnalytics - pageStart: ', self.debugColor, window[self.adobeDataLayerName].page.loadStart);
        }
        catch (e) {
            self.debug && console.log('%cAnalytics - pageStart - Error', self.debugColor, e);
        }
    }
    /**
     * @ignore
     */
    trackState(pageName, custom) {
        const self = this;
        try {
            pageName && self.setData('page.name', pageName);
            custom && self.setData('custom', custom);
            window[self.adobeDataLayerName].page.url || self.setData('page.url', document.location.href);
            self.setData('rule', 'pageLoad');
            self.setData('page.loadEnd', (new Date).getTime());
            self.setData('page.loadTime', window[self.adobeDataLayerName].page.loadEnd - window[self.adobeDataLayerName].page.loadStart);
            self.dataLayerParser();
            if (self.debug) {
                console.log('%cAnalytics - trackState - pageName: ', self.debugColor, window[self.adobeDataLayerName].page.name);
                console.log('%cAnalytics - trackState - pageUrl: ', self.debugColor, window[self.adobeDataLayerName].page.url);
                console.log('%cAnalytics - trackState - custom: ', self.debugColor, window[self.adobeDataLayerName].custom);
                console.log('%cAnalytics - trackState - loadEnd: ', self.debugColor, window[self.adobeDataLayerName].page.loadEnd);
                console.log('%cAnalytics - trackState - loadTime: ', self.debugColor, window[self.adobeDataLayerName].page.loadTime);
            }
            // Reset Data Layer
            window['google_tag_manager'] && window['google_tag_manager'][self.gtmContainerId].dataLayer.reset();
            // Trigger do GTM
            window['dataLayer'].push({ 'event': 'async_content_load', 'analyticsData': JSON.parse(JSON.stringify(window[self.adobeDataLayerName])) });
            // Clean not Required dataLayer Variables
            self.setData('transaction', {});
            self.setData('custom', {});
            self.setData('ecommerce', {});
        }
        catch (e) {
            self.debug && console.log('%cAnalytics - trackState - Error', self.debugColor, e);
        }
    }
    /**
     * @ignore
     */
    trackAction(custom) {
        const self = this;
        if (self.enabled) {
            try {
                custom && self.setData('custom', custom);
                self.setData('rule', 'customLink');
                self.debug && console.log('%cAnalytics - trackAction: ', self.debugColor, window[self.adobeDataLayerName].custom);
                // Fallback para os Eventos
                var componentclicked = window[self.adobeDataLayerName].custom.componentclicked ||
                    window[self.adobeDataLayerName].custom.ComponentClicked ||
                    window[self.adobeDataLayerName].custom.actioninfo;
                if (componentclicked) {
                    self.setData('custom.customCategory', componentclicked.match(/(MO:+)([^|]*)/)[2] +
                        '|' + componentclicked.match(/(TP:+)([^|]*)/)[2] +
                        '|' + componentclicked.match(/(PO:+)([^|]*)/)[2]);
                    self.setData('custom.customAction', componentclicked.match(/(AC:+)([^|]*)/)[2]);
                    self.setData('custom.customLabel', componentclicked.match(/(ID:+)([^|]*)/)[2]);
                }
                // Define se não é um hit de interação
                if (!custom.hasOwnProperty('noninteractionhit') && self.isNonInteractionHit(custom['customAction'])) {
                    self.setData('custom.events.noninteractionhit', 1);
                }
                // Reset Data Layer
                window['google_tag_manager'] && window['google_tag_manager'][self.gtmContainerId].dataLayer.reset();
                // Trigger do GTM
                window['dataLayer'].push({
                    'event': 'async_content_load',
                    'analyticsData': JSON.parse(JSON.stringify(window[self.adobeDataLayerName]))
                });
                // Clean not Required dataLayer Variables
                self.setData('transaction', {});
                self.setData('custom', {});
                self.setData('ecommerce', {});
            }
            catch (e) {
                self.debug && console.log('%cAnalytics - trackAction - Error', self.debugColor, e);
            }
        }
    }
    /* ============================================================================= */
    /*** Funções auxiliares
    /* ============================================================================= */
    /**
     * @ignore
     */
    isNonInteractionHit(action) {
        /**
         * Identifica se o Evento deve ser considerado interação ou não
         * @param action: Ação do evento
         */
        const self = this;
        try {
            // Lista de ações que não são consideredados por padrão interação
            var listNonInteractionHit = [
                'Show'
            ];
            return listNonInteractionHit.indexOf(action) !== -1 ? true : false;
        }
        catch (e) {
            self.debug && console.log('%cAnalytics - trackAction - Error', self.debugColor, e);
        }
    }
    ;
    /**
     * @ignore
     */
    getTimeStamp() {
        /**
         * Gera um timeStamp no formado ISO string
         */
        const self = this;
        try {
            var now = new Date(), tzo = -now.getTimezoneOffset(), dif = tzo >= 0 ? '+' : '-';
            var pad = function (num) {
                var norm = Math.abs(Math.floor(num));
                return (norm < 10 ? '0' : '') + norm;
            };
            return now.getFullYear()
                + '-' + pad(now.getMonth() + 1)
                + '-' + pad(now.getDate())
                + 'T' + pad(now.getHours())
                + ':' + pad(now.getMinutes())
                + ':' + pad(now.getSeconds())
                + '.' + pad(now.getMilliseconds())
                + dif + pad(tzo / 60)
                + ':' + pad(tzo % 60);
        }
        catch (e) {
            self.debug && console.log('%cAnalytics - getTimeStamp - Error', self.debugColor, e);
        }
    }
    /**
     * @ignore
     */
    hasProp(obj, propPath, i) {
        /**
         * Verifica se uma propriedade ou propriedades filhas existem
         */
        const self = this;
        try {
            if (typeof (i) === 'undefined' && !(i = 0)) {
                propPath = propPath.split('.');
            }
            if (typeof (obj[propPath[i]]) !== 'undefined') {
                return (++i && i !== propPath.length) ? this.hasProp(obj[propPath[i - 1]], propPath, i) : true;
            }
            return false;
        }
        catch (e) {
            self.debug && console.log('%cAnalytics - hasProp - Error', self.debugColor, e);
        }
    }
    ;
    /**
     * @ignore
     */
    dataLayerParser() {
        /**
         * Realiza todas conversões para deixar as implementações Adobe no formato Google configurado no GTM
         * e faz o push no dataLayer
         */
        const self = this;
        try {
            // Transforma o array dos eventos Adobe (chave 'events') em parâmetros de um objeto (chave: valor)
            try {
                let arrayEvents = window[self.adobeDataLayerName].custom.events;
                if (arrayEvents && arrayEvents.length > 0) {
                    let objEvents = {};
                    arrayEvents.forEach(function (e) {
                        objEvents[e.split('=')[0]] = e.split('=')[1] || '1';
                    });
                    self.setData('custom.events', objEvents);
                }
            }
            catch (e) {
                self.debug && console.log('Ocorreu um erro na conversão dos Eventos: ' + e);
            }
            // Criar novos parâmetros no dataLayer a partir dos classifications
            let classificationValue, classPairArr;
            try {
                self.listClassification.forEach(function (classification) {
                    try {
                        classificationValue = eval(self.adobeDataLayerName + '.' + classification).replace(/(^\|)|(\|$)/g, "");
                    }
                    catch (e) { }
                    if (classificationValue) {
                        self.setData(classification, {});
                        classificationValue.split('|').map(function (classPairStr) {
                            classPairArr = classPairStr.split(':');
                            self.adobeToGoole[(classification + '.' + classPairArr[0])] &&
                                self.setData(self.adobeToGoole[(classification + '.' + classPairArr[0])], classPairArr[1]);
                        });
                    }
                    classificationValue = undefined;
                });
            }
            catch (e) {
                self.debug && console.log('Ocorreu um erro ao converter as dimensões antigas com classifications: ' + e);
            }
            for (let prop in self.adobeToGoole) {
                try {
                    if (self.adobeToGoole.hasOwnProperty(prop)) {
                        eval(self.adobeDataLayerName + '.' + prop) &&
                            self.setData(self.adobeToGoole[prop], eval(self.adobeDataLayerName + '.' + prop));
                    }
                }
                catch (e) {
                    // Não ativar LOG, pois sempre vai ter um 'erro' na função eval
                    // console.log(e) 
                }
            }
            // Fallback para antigo classification Survey Response (Feedback/Avaliação)
            if (self.hasProp(window[self.adobeDataLayerName], 'custom.surveyresponse')) {
                try {
                    self.setData('custom.survey.feedbackname', window[self.adobeDataLayerName].custom.surveyresponse.match(/(NM:+)([^|]*)/)[2]);
                    self.setData('custom.survey.questionsandanswers', window[self.adobeDataLayerName].custom.surveyresponse.match(/(Q([^;]*):+)([^|]*)/)[0]);
                }
                catch (e) {
                    self.debug && console.log('Ocorreu um erro na conversão de Survey Response: ' + e);
                }
            }
            // Fallback para Google Hit Timestamp
            self.hasProp(window[self.adobeDataLayerName], 'custom.hittimestamp') || self.setData('custom.hittimestamp', self.getTimeStamp());
            // Fallback para GTM Container ID
            self.hasProp(window[self.adobeDataLayerName], 'site.gtmcontainerid') || self.setData('site.gtmcontainerid', self.gtmContainerId);
            // Fallback para Google Session ID
            // Ou usar outra lógica para geração do identificador
            self.hasProp(window[self.adobeDataLayerName], 'visitor.sessionid') || self.setData('visitor.sessionid', Date.now() + Math.round((Math.random() * 100000000)));
        }
        catch (e) {
            self.debug && console.log('%cAnalytics - dataLayerParser - Error', self.debugColor, e);
        }
    }
    ;
    /**
     * @ignore
     */
    setData(param, value) {
        const self = this;
        if (self.enabled) {
            try {
                if (self.adobeDataLayerName === param) {
                    window[self.adobeDataLayerName] = value;
                    window[self.adobeDataLayerName] = window[self.adobeDataLayerName];
                    self.debug && console.log('%cAnalytics - setData: ', self.debugColor, self.adobeDataLayerName + ' = ', value);
                    return true;
                }
                let analyticsParam = window[self.adobeDataLayerName];
                let i;
                const params = param.split('.');
                try {
                    for (i = 0; i < params.length - 1; i++) {
                        if (analyticsParam[params[i]] === undefined) {
                            analyticsParam[params[i]] = {};
                        }
                        analyticsParam = analyticsParam[params[i]];
                    }
                    analyticsParam[params[i]] = value;
                    self.debug && console.log('%cAnalytics - setData: ', self.debugColor, self.adobeDataLayerName + '.' + param + ' = ', analyticsParam[params[i]]);
                }
                catch (e) { }
            }
            catch (e) {
                self.debug && console.log('%cAnalytics - setData - Error', self.debugColor, e);
            }
        }
    }
}
Analytics.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: Analytics, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
Analytics.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: Analytics, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: Analytics, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

/**
 * Esta libreria contiene los metodos que haran conexión con Google Tag Manager para el Banco Itaú en aplicaciones web en Angular.
 */
class DaliService {
    /**
     * @param analyticsLib Servicio de la libreria Analytics
     * @param httpClient  Servicios y metodos HttpClient para obtener JSON del archivo analytics-data.json
     */
    constructor(analyticsLib, httpClient) {
        this.analyticsLib = analyticsLib;
        this.httpClient = httpClient;
    }
    /**
     * Método que se encarga de inicializar la lib analytics
     *
     * @param string gtmContainerId este parametro es el codigo del container de Google Tag Manager que recibira los datos
     * @param boolean isProd este parametro indica si la aplicacion se encuentra en ambiente de desarrollo
     * @param string analyticsJsonURL este parametro contiene la URL en donde se encuentra alojado el JSON inicial
     * @example initAnalytics('GTM-M973827', false, 'http://localhost:4200/assets/analytics/analytics-data.json')
     * @throws analitycsError
     */
    initAnalytics(gtmContainer, isProd, analyticsJsonURL) {
        const initObject = {
            gtmContainerId: gtmContainer,
            autoTrackState: false,
            debug: isProd ? false : true
        };
        return new Promise((resolve, reject) => {
            if (analyticsJsonURL) {
                this.getAnalyticsJSON(analyticsJsonURL)
                    .then(data => {
                    this.analyticsData = data;
                    this.analyticsLib.init(initObject);
                    resolve(true);
                })
                    .catch(err => {
                    reject(err);
                });
            }
            else {
                reject('Debe definir URL de objeto analytics JSON');
            }
        });
    }
    /**
     * Método que se encarga de hacer un page view hacia Google Analytics
     *
     * @param IPageLoadModel arreglo  que contiene los valores de cambio del dataLayer que se envia a Google Analytics en el metodo setData
     * @example pageLoad([{path:'page.name',value:'APN:CO:PF:NL:Tarjetas:Credito:Solicitar:SeleccionaCiudadOficina'},
     * {path:'custom.events.transactionstep01', value:'1'}])
     */
    pageLoad(changes) {
        if (this.analyticsData) {
            this.analyticsLib.setData('analyticsData', this.analyticsData);
            for (const change of changes) {
                this.analyticsLib.setData(change.path, change.value);
            }
            this.analyticsLib.trackState(null, null);
        }
        else {
            throw new Error('Falta definir objeto analytics JSON');
        }
    }
    /**
     * Metodo que envia evento a Google Analytics
     *
     * @param ITrackEventModel objeto que contiene los valores que deben asignarse al objeto del evento en la libreria Analytics
     * @example trackEvent({category:{module:'Body',type:'TextField',position:'Center'},label:'BuscarCiudad',
     * action:'Click',events:[{name:'transactionsimulationvalue',value:'200000'}]})
     */
    trackEvent(event, changes) {
        let eventObject;
        if (changes) {
            for (const change of changes) {
                this.analyticsLib.setData(change.path, change.value);
            }
        }
        if (this.analyticsData) {
            eventObject = {
                customCategory: `${event.category.module} | ${event.category.type} | ${event.category.position}`,
                customAction: event.action,
                customLabel: event.label
            };
            if (event.errorName) {
                // eslint-disable-next-line
                eventObject['errorname'] = event.errorName;
            }
            if (event.messageEvent) {
                // eslint-disable-next-line
                eventObject['message'] = event.messageEvent;
            }
            if (event.searchTerm) {
                // eslint-disable-next-line
                eventObject['searchterm'] = event.searchTerm;
            }
            if (event.events) {
                // eslint-disable-next-line
                eventObject['events'] = {};
                for (const object of event.events) {
                    // eslint-disable-next-line
                    eventObject.events[object.name] = object.value;
                }
            }
            if (event.value) {
                // eslint-disable-next-line
                eventObject['customValue'] = event.value;
            }
            // eslint-disable-next-line
            this.analyticsLib.trackAction(eventObject);
            // eslint-disable-next-line
            this.eventObject = eventObject;
            eventObject = {};
        }
        else {
            throw new Error('Falta definir objeto analytics JSON');
        }
    }
    /**
     * Metodo que obtiene el dataLayer para la libreria Analytics en el metodo setData
     *
     * @returns objeto dataLayer
     */
    getAnalyticsData() {
        // eslint-disable-next-line
        return this.analyticsData;
    }
    /**
     * Metodo que obtiene el eventObject
     *
     * @returns objeto eventObject
     */
    getEventObject() {
        // eslint-disable-next-line
        return this.eventObject;
    }
    /**
     * Metodo que obtiene el codigo de identificacion del usuario en sesion
     *
     * @returns el PPID y el tipo de usuario logueado
     */
    /*public getPPID() {}*/
    /**
     * Metodo que obtiene el JSON del documento analytics-data
     *
     * @param string url este parametro es la URL de posicion del archivo analytics-data
     * @example getAnalyticsJSON('http://localhost:4200/assets/analytics/analytics-data.json')
     * @returns objeto JSON
     */
    getAnalyticsJSON(url) {
        return __awaiter(this, void 0, void 0, function* () {
            const urlAnalytics$ = this.httpClient.get(url);
            //return await lastValueFrom(urlAnalytics$);
            return yield urlAnalytics$.toPromise();
        });
    }
}
DaliService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DaliService, deps: [{ token: Analytics }, { token: HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
DaliService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DaliService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DaliService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: Analytics, decorators: [{
                    type: Inject,
                    args: [Analytics]
                }] }, { type: i2.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }]; } });

class DaliModule {
}
DaliModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DaliModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DaliModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DaliModule });
DaliModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DaliModule, providers: [
        DaliService, Analytics, HttpClient
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: DaliModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [
                        DaliService, Analytics, HttpClient
                    ]
                }]
        }] });

/*
 * Public API Surface of dali12
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Analytics, DaliModule, DaliService };
